import request from '@/utils/request'
export const queryPage = '/icps/system/sign/cloudSell/engineeringManagement/QueryPage'
// export const Download = '/icps/system/sign/cloudSell/engineeringManagement/exportList'
export const Download = '/icps/system/sign/cloudSell/engineeringManagement/exportEngineering'
export function getExecutePhaseStatus(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/getExecutePhaseStatus',
    method: 'post',
    data
  })
}
export function udatePrincipal(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/udatePrincipal',
    method: 'post',
    data
  })
}
/**生产处客户列表 */
export function customerqueryPage(data) {
  return request({
    url: '/icps/system/sign/cloudSell/pro/customer/queryPage',
    method: 'post',
    data
  })
}
/**更改业务类型 */
export function updateMixRatio(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/updateMixRatio',
    method: 'post',
    data
  })
}
/**更改承接阶段 */
export function updateEngineering(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/updateEngineering',
    method: 'post',
    data
  })
}
/*协作客户列表 */
export function collaborateCustomers(params) {
  return request({
    url: "/icps/system/sign/dataCollection/contract/queryContractList",
    method: "get",
    params
  })
}
/**更改承接阶段 */
export function exportEngineering(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/exportEngineering',
    method: 'post',
    data
  })
}

